import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const reportTypesManagement = createApi({
    reducerPath: "reportTypesManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        reportTypesList: builder.mutation({
            query: () => ({
                url: `v1/${locale}/settings/report-types`,
                method: "GET",
            }),
        }),

        addReportTypes: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/report-types`,
                method: "POST",
                body: body,
            }),
        }),

        viewReportTypes: builder.mutation({
            query: (reportTypeId) => ({
                url: `v1/${locale}/settings/report-types/${reportTypeId}`,
                method: "GET",
            }),
        }),

        deleteReportTypes: builder.mutation({
            query: (reportTypeId) => ({
                url: `v1/${locale}/settings/report-types/${reportTypeId}`,
                method: "DELETE",
            }),
        }),

        updateReportTypes: builder.mutation({
            query: ({ body, reportTypeId }) => ({
                url: `v1/${locale}/settings/report-types/${reportTypeId}`,
                method: "PATCH",
                body: body,
            }),
        }),
    }),
});

export const { 
    useReportTypesListMutation,
    useDeleteReportTypesMutation,
    useViewReportTypesMutation,
    useUpdateReportTypesMutation,
    useAddReportTypesMutation
} = reportTypesManagement;
